// extracted by mini-css-extract-plugin
module.exports = {"wraozhf":"wraozhf"};